import { render, staticRenderFns } from "./currencySelect.vue?vue&type=template&id=2d051cc6"
import script from "./currencySelect.vue?vue&type=script&lang=js"
export * from "./currencySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports